// import { setToken, getToken, delToken } from '@/utils/storage'
//
// export default {
//   namespaced: true,
//   state () {
//     return {
//       token: getToken()
//     }
//   },
//   mutations: {
//     // 设置state中的token 并且存到本地
//     setUserToken (state, payload) {
//       // payload=> token
//       state.token = payload
//       setToken(payload)
//     },
//     // 退出操作
//     logout (state) {
//       state.token = null
//       delToken()
//     }
//   }
// }
const user = {
    state: {
        token: "",
        name: '',
    },
    mutations: {
        SET_TOKEN: (state, token) => {
          state.token = token;
        },
    },
    actions: {
        // 投资报告个人信息
        getTokenInfo({commit},view){
            commit('SET_TOKEN', view);
        },
    }
};
  
export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js